import { render, staticRenderFns } from "./TacoRating.vue?vue&type=template&id=2c9a2615&scoped=true&"
import script from "./TacoRating.vue?vue&type=script&lang=js&"
export * from "./TacoRating.vue?vue&type=script&lang=js&"
import style0 from "./TacoRating.vue?vue&type=style&index=0&id=2c9a2615&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a2615",
  null
  
)

export default component.exports